import Api from '@/services/Api'
// import { log } from 'util';

export default {
  testping(search) {
    return Api().get('pondi/testping', {
      params: search
    })
  },
  testams(search) {
    return Api().get('pondi/testams', {
      params: search
    })
  },
  testxml(doc) {
    return Api().post('pondi/testxml', doc)
  },
  sendxml(doc) {
    return Api().post('pondi/sendxml', doc)
  },
  getxml(search) {
    return Api().get('pondi/getxml', {
      params: search
    })
  },
  getvisualxml(search) {
    return Api().get('pondi/getvisualxml', {
      params: search
    })
  },
  getulazni(search) {
    return Api().get('pondi/getulazni', {
      params: search
    })
  },
  getizlazni(search) {
    return Api().get('pondi/getizlazni', {
      params: search
    })
  },
  getstatusdok(search) {
    return Api().get('pondi/getstatusdok', {
      params: search
    })
  },
  promjenastatus(doc) {
    return Api().post('pondi/promjenastatus', doc)
  },

  // eizvjestavanje
  evidentirajdokument(doc) {
    return Api().post('pondi/evidentirajdokument', doc)
  },
  oznacinaplacenid(doc) {
    return Api().post('pondi/oznacinaplacenid', doc)
  },
  oznacinaplacen(doc) {
    return Api().post('pondi/oznacinaplacen', doc)
  },
  oznaciodbijenid(doc) {
    return Api().post('pondi/oznaciodbijenid', doc)
  },
  oznaciodbijen(doc) {
    return Api().post('pondi/oznaciodbijen', doc)
  },
  eizvjestavanjereport(search) {
    return Api().get('pondi/eizvjestavanjereport', {
      params: search
    })
  }
}